<template>
  <div class="hello">
    <h1 class="title">{{ msg }}</h1>
    <h2 class="Description">
      {{ des }}
      <a href="https://www.instagram.com/weedmusic.io/">
      <iconify-icon data-icon="mdi-instagram" style="color: #42b983;"></iconify-icon>
    </a>
    </h2>
  </br>
  </div>
</template>

<script>
export default {
  name: 'WeedMusic',
  props: {
    msg: String,
    des: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .title {
    font-size: 8em;
    margin: 0em;
    padding: 0em;
  }
  @media (max-width: 700px) {
    .title {
      font-size: 3em;

    }

  }
</style>
